// material-ui
import { Link } from '@mui/material';

import { DASHBOARD_PATH } from 'src/config';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
    <Link href={DASHBOARD_PATH}>
        <img alt="New Payment Innovation" src="/images/npi-logo-white-text.png" width="62px" />
    </Link>
);

export default LogoSection;
